<template>
  <div>
    <space></space>
    <div class="toast toast--success">
      <button class="btn-close" v-on:click="$emit('close')"></button>
      <h6>{{ label }}</h6>
      <p>{{ message }}</p>
    </div>
  </div>
</template>
<script>
module.exports = {
  name: "toast-success",
  props: ["label", "message"]
};
</script>
